import { createProgramItem } from "../../../apis/wpApi/apiCalls"
import actionTypes from "../../../actions/actionTypes"
import { call, select, put } from "redux-saga/effects"
import { overlaySetRequestType, getProgramData, onSuccess, onError } from "./request"
import { ADVERTISEMENT_DEFAULT, AD_DEFAULT, HIGHLIGHT_DEFAULT, WEISCHERAD_DEFAULT } from "../../../constants/state"
import { OBJ_SELECTIONDISPLAY, OBJ_SELECTION, OBJ_AD, OBJ_HIGLLIGHT, OBJ_WEISCHER, OBJ_ADVERTISEMENT } from "../../../constants/objectTypes"
import { advertisementsItemOrderSelector, advertisementsOrderSelector, displaySelectionItemOrderSelector, displaySelectionOrderSelector } from "."
import authUser from "../../../apis/wpApi/authUser"


function* putCreateRequest(actionType) {
    yield put({
        type: actionType
    })
}

function* putNewItem(actionType, data) {
    if(data) {
        return yield put({
            type: actionType,
            meta: {},
            payload: data
        })
    } else {
        return yield false
    }
}

function* getItemDataObject(objectType, data) {
    return yield {
        data: {
            ... data,
            draft: true
        },
        objectType: objectType
    }
}

function* createNewItem(objectType, data) {
    try {
        yield call(putCreateRequest, actionTypes.PROGRAM_CREATE_ITEM_REQUEST)
        yield call(overlaySetRequestType, actionTypes.PROGRAM_CREATE_ITEM_REQUEST)

        if(_.has(data, "movieRefID")){ 
            data.movieRefID = data.movieRefID
        }

        const itemData = yield getItemDataObject(objectType, data)
        const apiKey = yield call(authUser.getToken)
        const reponse = yield call(createProgramItem, apiKey, itemData)
        const newItemData = yield getProgramData(reponse)

        yield call(onSuccess, actionTypes.PROGRAM_CREATE_ITEM_SUCCESS, false, false)

        return yield newItemData
    } catch(e) {
        yield call(onError, actionTypes.PROGRAM_CREATE_ITEM_ERROR, e.message)

        return yield false
    }
}

export function* createNewSelectionDisplay(type, selectionPk) {
    const order = yield select(displaySelectionOrderSelector)
    const lastItemPk = order.last()
    const lastItemOrder = yield select(displaySelectionItemOrderSelector, lastItemPk)
    const firstOrderValueIncreased = lastItemOrder.first() + 1
    const lastOrderValue = lastItemOrder.last()

    const itemData = yield call(createNewItem, OBJ_SELECTIONDISPLAY, {
        type: type,
        selectionPk: selectionPk,
        order: [firstOrderValueIncreased, lastOrderValue]
    })

    return yield call(putNewItem, actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM, itemData)
}


export function* createNewSelection(title = null, filterType = null, filterValue = null, expireDate = null, showInApp = false, style, trailerAutoplay, cinemasFilter, collections = [])  {
    const itemData = yield call(createNewItem, OBJ_SELECTION, {
        title: title,
        filterType: filterType,
        filterValue: filterValue,
        expireDate: expireDate,
        collections: collections,
        showInApp: showInApp,
        style: style,
        cinemasFilter: cinemasFilter,
        trailerAutoplay: trailerAutoplay
    })

    return yield call(putNewItem, actionTypes.ITEMSELECTIONS_ADD_ITEM, itemData)
}

export function* createNewHighlight(data) {
    const itemData = yield call(createNewItem, OBJ_HIGLLIGHT, yield _.defaults(data, HIGHLIGHT_DEFAULT))

    return yield call(putNewItem, actionTypes.HIGHLIGHTS_ADD_ITEM, itemData)
}

export function* createNewWeischerAd(data) {
    const itemData = yield call(createNewItem, OBJ_WEISCHER, yield _.defaults(data, WEISCHERAD_DEFAULT))

    return yield call(putNewItem, actionTypes.WEISCHERAD_ADD_ITEM, itemData)
}

export function* createNewAd(data) {
    const itemData = yield call(createNewItem, OBJ_AD, yield _.defaults(data, AD_DEFAULT))

    return yield call(putNewItem, actionTypes.ADS_ADD_ITEM, itemData)
}

export function* createNewAdvertisement(data) {
    const order = yield select(advertisementsOrderSelector)
    let firstOrderValueIncreased
    let lastOrderValue

    if(0 !== order.size)  {
        const lastItemPk = order.last()
        const lastItemOrder = yield select(advertisementsItemOrderSelector, lastItemPk)

        firstOrderValueIncreased = lastItemOrder.first() + 1
        lastOrderValue = lastItemOrder.last()

    } else {
        firstOrderValueIncreased = 1
        lastOrderValue = 1
    }

    const itemData = yield call(createNewItem, OBJ_ADVERTISEMENT, yield _.defaults(data, {
        ... ADVERTISEMENT_DEFAULT,
        order: [firstOrderValueIncreased, lastOrderValue]
    }))

    return yield call(putNewItem, actionTypes.ADVERTISEMENTS_ADD_ITEM, itemData)
}
